import { Box, Dialog, Grid, IconButton } from "@mui/material";

const styles = {
  closeIcon: {
    fontSize: 16,
    mt: 4,
    mr: 2,
  },
};

interface Props {
  children: React.ReactNode;
  handleClose?: () => void;
  isMobileScreen?: boolean;
  isDialog?: boolean;
}

const CreateTemplateDialogWrapper = ({
  children,
  handleClose,
  isMobileScreen,
  isDialog,
}: Props) => {
  if (!isDialog) {
    return <>{children}</>;
  }
  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      scroll="body"
      fullScreen={isMobileScreen}
      open={true}
      onClose={handleClose}
    >
      <Grid container justifyContent="flex-end">
        <IconButton sx={styles.closeIcon} onClick={handleClose}>
          <Box component="i" className="fa-regular fa-xmark" />
        </IconButton>
      </Grid>
      {children}
    </Dialog>
  );
};

export default CreateTemplateDialogWrapper;
